/**
 * axios的封装
 */
import axios from 'axios';
import qs from 'qs';

axios.defaults.baseURL = 'http://118.190.210.223:8090'
// axios.defaults.timeout = 50000// 请求超时时间

export default {
    // get方式
    get(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params
            })
                .then(response => {
                    resolve(response.data) // 成功的数据
                })
                .catch(err => {
                    reject(err) // 失败的数据
                })
        })
    },
    // post方式
    post(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, qs.stringify(params))
                .then(response => {

                    if (response.data.status == 20029) {
                        window.location.href = window.location.origin + "/#/"
                    }
                    resolve(response.data) // 成功的数据
                })
                .catch(err => {
                    reject(err) // 失败的数据
                })
        })
    }
}




// WEBPACK FOOTER //
// ./src/utils/request.js